// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD5eXFD0HkNc4s2H_dWuVD6nzbIH1h-4P0",
  authDomain: "the-traveler-a385d.firebaseapp.com",
  projectId: "the-traveler-a385d",
  storageBucket: "the-traveler-a385d.appspot.com",
  messagingSenderId: "387272373155",
  appId: "1:387272373155:web:c7fe536443d04227ebe016"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;